import { nortadaLogger } from '../components/common/logger';

const voiceSessionCloseReasonQueryToString = (reason: string): string => {
  const translations: Record<string, string> = {
    END: 'End',
    ABANDON: 'Abandon',
    TIMEOUT: 'Timeout',
    NOT_CLOSED_YET: 'Session in progress'
  };

  return translations[reason] ?? nortadaLogger.critical(`${reason} is unsupported Voice session close reason query.`);
};

export default voiceSessionCloseReasonQueryToString;
